/** @format **/
import React, { FunctionComponent, ReactElement } from 'react';
import { MnoMessageInterface } from '../../interfaces/collections/MnoMessageInterface';
import { TableCell, TableRow } from '@material-ui/core';
import { DateHelperTs } from '../../helpers/DateHelperTs';
import I18n from '../../components/Translate/I18n';
import SimCardInterface from '../../interfaces/platform/SimCardInterface';
import ViewButton from '../../components/Buttons/ViewButton';
import OPL_STYLE from '../../assets/themes/OPL/OplStyle';
import withStyles from "@material-ui/core/styles/withStyles";
import OplAppStyle from "../../assets/themes/OPL/jss/App/OplAppStyle";

type MnoMessageItemType = {
    classes: any;
    mnoMessage: MnoMessageInterface;
    setActiveRow: (id: number) => void;
    activeRow: number;
    viewCallback: (mnoMessage: MnoMessageInterface) => void;
    simCard?: SimCardInterface | null;
};

const MnoMessageItem: FunctionComponent<MnoMessageItemType> = ({
    classes,
    mnoMessage,
    setActiveRow,
    activeRow,
    viewCallback,
    simCard,
}): ReactElement => {
    const tableControlStickyHeader = {root: classes.tableControlStickyHeader};
    const tableCellRoot = {root: classes.tableCellRootBordered};
    const tableRowRoot = {root: classes.tableRowRoot};

    let rowActiveColor = 'none';
    if (activeRow === mnoMessage.id) {
        rowActiveColor = OPL_STYLE.TABLE.ACTIVE_ROW;
    }

    const getBooleanAsString = (value: boolean): string => {
        if (value) {
            return 'general:common.yes';
        }
        return 'general:common.no';
    };

    return (
        <TableRow
            classes={tableRowRoot}
            key={'key' + mnoMessage.id}
            hover
            onClick={(): void => {
                setActiveRow(mnoMessage.id);
            }}
            style={{ backgroundColor: rowActiveColor }}
        >
            <TableCell classes={tableControlStickyHeader} padding="none" align="left">
                <ViewButton
                    callback={viewCallback}
                    callbackParam={{ ...mnoMessage }}
                    tooltipTitle="prov:features.view_features"
                    tooltipPlacement="bottom-start"
                />
            </TableCell>
            {!simCard && (
                <TableCell classes={tableCellRoot} padding="none" align="left">
                    {mnoMessage.msisdn}
                </TableCell>
            )}
            <TableCell classes={tableCellRoot} padding="none" align="left">
                {mnoMessage.notifyType}
            </TableCell>
            <TableCell classes={tableCellRoot} padding="none" align="left">
                <I18n trans={getBooleanAsString(mnoMessage.processed)} />
            </TableCell>
            <TableCell classes={tableCellRoot} padding="none" align="left">
                <I18n trans={getBooleanAsString(mnoMessage.exception)} />
            </TableCell>
            <TableCell classes={tableCellRoot} padding="none" align="left">
                <I18n trans={getBooleanAsString(mnoMessage.xmlParseError)} />
            </TableCell>
            <TableCell classes={tableCellRoot} padding="none" align="left">
                {DateHelperTs.format(mnoMessage.createdAt, 'YYYY-MM-DD HH:mm:ss')}
            </TableCell>
            <TableCell classes={tableCellRoot} padding="none" align="left">
                {mnoMessage.processedTime && DateHelperTs.format(mnoMessage.processedTime, 'YYYY-MM-DD HH:mm:ss')}
            </TableCell>
        </TableRow>
    );
};

export default withStyles(OplAppStyle)(MnoMessageItem);